/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanitySummaryDetailInfo = {
    VAL?: string;
    CHGRT?: string;
    CHGDIR?: HumanitySummaryDetailInfo.CHGDIR;
};

export namespace HumanitySummaryDetailInfo {

    export enum CHGDIR {
        UP = 'UP',
        DOWN = 'DOWN',
        FLAT = 'FLAT',
    }


}

